/**************************************************
 * Nombre:       RelojProcesando
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Typography} from "@mui/material";
import Countdown from "react-countdown";
import {useEffect, useState} from "react";

const RelojJueves = ({setActivo}) => {
    const [fecha, setFecha] = useState('');
    const [esJueves, setEsJueves] = useState(false)

    const renderer = ({days, hours, minutes, seconds, completed}) => {


        if (esJueves) {
            setActivo(completed)
            return <span>{`${hours}h-${minutes}m-${seconds}s`}</span>;
        } else {
            setActivo(!completed)
            return <span>{`${days}d-${hours}h-${minutes}m-${seconds}s`}</span>;
        }


    };

    function proximoJueves5am() {
        const hoy = new Date();
        const resultado = new Date(hoy);

        // Día actual (0=domingo, 1=lunes, ..., 6=sábado)
        const diaSemana = hoy.getDay();
        const jueves = 4; // jueves es el día 4

        // Calcular cuántos días faltan para el próximo jueves
        let diasFaltantes = (jueves - diaSemana + 7) % 7;

        // Si hoy ya es jueves y son las 5am o más, pasar al siguiente jueves
        if (diasFaltantes === 0 && hoy.getHours() >= 5) {
            diasFaltantes = 7;
        }

        resultado.setDate(hoy.getDate() + diasFaltantes);
        resultado.setHours(5, 0, 0, 0); // Fijar hora exacta 5:00 AM

        return resultado;

    }

    const tranformarFecha = () => {

        let fecha = new Date()

        let diaHoy = fecha.getDay()

        if (diaHoy === 4) { //4 es jueves
            setEsJueves(true)
            return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), 17, 0, 0)
        } else {
            setActivo(true)
            return proximoJueves5am()
        }


    }

    useEffect(() => {
        setFecha(tranformarFecha())
    }, []);
    return (
        <Typography sx={{
            fontSize: 12,
            color: '#054073',
            fontWeight: 400,
            textAlign: 'center',
            lineHeight: 1.1
        }}>{esJueves ? "Activo hasta: " : "Se activara en:"}<br/>
            {fecha &&
                <Countdown
                    daysInHours={true}
                    date={fecha}
                    renderer={renderer}
                />
            }
        </Typography>
    )

}
export default RelojJueves